import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { goToPurchase } from '../lib/checkout';
interface CTAButtonProps {
  label: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  label,
  className = '',
  fullWidth = true
}: CTAButtonProps) {
  return <motion.button onClick={goToPurchase} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} animate={{
    boxShadow: ['0 0 0 0 rgba(249,115,22,0.5)', '0 0 0 14px rgba(249,115,22,0)']
  }} transition={{
    boxShadow: {
      duration: 1.8,
      repeat: Infinity
    }
  }} className={`inline-flex items-center justify-center gap-2 rounded-xl bg-orange-500 px-6 py-4 text-base font-extrabold uppercase tracking-wide text-black shadow-lg transition-colors hover:bg-orange-400 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-119">
      {label}
      <ArrowRightIcon className="h-5 w-5" data-id="element-120" />
    </motion.button>;
}